import {
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";

interface ModalRecuperarSenhaProps {
  visible: boolean;
  onClose: () => void;
}

function TermoPoliticaModal({ onClose, visible }: ModalRecuperarSenhaProps) {
  return (
    <Modal size="5xl" isOpen={visible} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="900px">
        <ModalHeader>Condições e regulamento para compra ingresso.</ModalHeader>
        <ModalCloseButton />

        <Divider mb={5} />
        <ModalBody>
          <Stack spacing={2}>
            <Text fontSize="lg">
              1. Os ingressos são válidos por até 30 (trinta) dias contados da
              data da compra. Caso o visitante não compareça na data inicialmente
              selecionada, o ingresso poderá ser utilizado dentro desse período,
              sem necessidade de remarcação, observados os dias e horários de
              funcionamento do parque. Nos termos do art. 49 da Lei nº
              8.078/1990 (Código de Defesa do Consumidor), as compras realizadas
              pelo site poderão ser canceladas no prazo de até 7 (sete) dias
              contados da data da compra, com direito ao reembolso integral dos
              valores pagos, desde que nenhum dos ingressos vinculados à compra
              tenha sido utilizado. Caso o cliente utilize um ou mais ingressos
              da mesma compra, não será possível o cancelamento parcial nem o
              reembolso proporcional dos ingressos remanescentes, uma vez que a
              compra será considerada parcialmente executada. Nessa hipótese, os
              ingressos ainda não utilizados permanecerão válidos e poderão ser
              utilizados normalmente até o término do seu prazo de validade. Após
              o prazo de 7 (sete) dias previsto no art. 49 do Código de Defesa
              do Consumidor, não será possível solicitar o cancelamento ou o
              reembolso da compra. Ingressos adquiridos em campanhas
              promocionais, ações especiais ou condições diferenciadas poderão
              possuir regras e prazos de validade específicos, conforme
              regulamento da respectiva campanha.
            </Text>

            <Text fontSize="lg">
              2. É obrigatória a apresentação de documento oficial com foto para
              acesso ao parque.
            </Text>

            <Text fontSize="lg">
              3. Ingressos promocionais antecipados estão disponíveis
              exclusivamente pelo site ou pontos de venda autorizados, não sendo
              vendidos na bilheteria do parque.{" "}
            </Text>

            <Text fontSize="lg">
              4. Aceitamos cartões de crédito Visa, Mastercard, American Express
              e Elo (em até 3x sem juros) e Pix. Compras internas no parque são
              aceitas somente à vista..
            </Text>

            <Text fontSize="lg">
              5. Crianças de até 5 anos têm entrada gratuita, desde que
              acompanhadas por um adulto e mediante apresentação de documento
              oficial com foto ou certidão de nascimento.
            </Text>

            <Text fontSize="lg">
              6. Crianças de 6 a 9 anos pagam ingresso infantil e devem estar
              acompanhadas por um adulto, com apresentação de documento oficial
              ou certidão de nascimento.
            </Text>

            <Text fontSize="lg">
              7. Tem direito a meia entrada por lei, estudantes, pessoas com
              idade superior a 60 anos e doadores de sangue, jornalistas e
              jovens de baixa renda.{" "}
              <strong>
                É obrigatória a apresentação de comprovante de meia-entrada
                válido por lei, para ingressos com esse benefício.
              </strong>
            </Text>

            <Text fontSize="lg">
              8. Pessoas com deficiência, com Síndrome de Down ou dentro do
              Espectro Autista, assim como acompanhantes quando comprovadamente
              necessários, têm gratuidade mediante laudo ou documento oficial.
              <strong>
                É obrigatória a apresentação de comprovante de gratuidade válido
                por lei, para ingressos com esse benefício.
              </strong>
            </Text>

            <Text fontSize="lg">
              9. O parque funciona aos sábados e domingos, das 9h às 17h,
              podendo sofrer alterações por motivos operacionais ou de força
              maior. Em caso de chuvas intensas, frio, ventos fortes ou raios, o
              parque poderá ser fechado a qualquer momento, visando à segurança
              dos visitantes. Fechamentos para manutenção interna serão
              comunicados previamente.
            </Text>

            <Text fontSize="lg">
              10. A administração pode interromper temporariamente atrações em
              caso de condições climáticas adversas, como forma de proteção aos
              visitantes.
            </Text>

            <Text fontSize="lg">
              11. O ÁCQUA PARK PANTANAL não se responsabiliza por ingressos
              adquiridos fora dos canais oficiais.
            </Text>

            <Text fontSize="lg">
              12. Não é permitido entrar com alimentos e bebidas, inclusive com
              itens para aniversário como bolos e doces. No caso de pessoas com
              restrição alimentar, será autorizada a entrada com o alimento,
              mediante apresentação do Laudo médico em quantidade suficiente
              para o portador da restrição.
            </Text>

            <Text fontSize="lg">
              13. A entrada e saída do parque durante o mesmo dia requer
              apresentação da requisição fornecida na portaria, devidamente
              carimbada.
            </Text>

            <Text fontSize="lg">
              14. O parque não se responsabiliza por objetos ou pertences
              pessoais.
            </Text>

            <Text fontSize="lg">
              15. É proibido o uso de substâncias entorpecentes, conforme a RDC
              143/17 da ANVISA. O descumprimento acarretará na retirada imediata
              do visitante.
            </Text>

            <Text fontWeight="black" fontSize="lg">
              16. A equipe técnica poderá restringir o uso das atrações em casos
              visíveis de doenças de pele ou lesões.
            </Text>

            <Text fontWeight="black" fontSize="lg">
              Nas piscinas, não é permitido: • Usar curativos, faixas, gesso,
              absorventes ou pomadas; • Utilizar bronzeadores, copos ou objetos
              de vidro; • Praticar brincadeiras perigosas; • Usar roupas com
              zíperes, botões ou metais; • Adotar comportamentos ofensivos ou
              inadequados.
            </Text>
            <Text fontWeight="black" fontSize="lg">
              18. Trajes permitidos: • Masculino: sunga ou calção com forro tipo
              tactel; • Feminino: biquíni, maiô ou shorts de malha.
            </Text>
            <Text fontWeight="black" fontSize="lg">
              19. O parque realiza gravações e registros de imagem em suas
              dependências. Ao adquirir o ingresso e acessar o parque, o cliente
              autoriza o uso gratuito e irrestrito de sua imagem para fins
              promocionais, institucionais ou comerciais, sem gerar direito à
              indenização.
            </Text>
            <Text fontWeight="black" fontSize="lg">
              20. Ao adquirir o ingresso, o cliente declara estar ciente e de
              acordo com todas as condições e regras estabelecidas neste
              regulamento.
            </Text>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TermoPoliticaModal;
